import {
    PROGRAM_INFO
} from "../../actions";
import http from "../../../service"
import {
    programInfo,
} from "../../../endPoints";

export const getProgramInfo = () => {
    return async dispatch => {
        const data = await http.postWebApi(programInfo);
        dispatch({type: PROGRAM_INFO, payload: data})
    };
};